// 产品研发数字化 · 双研发中心（成都 / 炉霍）协同数据
// 说明：当前为「框架期示例快照」——结构与字段按真实实验室系统（设备台账 / 环境传感器 / LIMS 实验结果）对齐，
//      后续接入真实数据时只需按同样结构替换，页面无需改动。
// 接口预留约定：/api/research/devices · /api/research/env · /api/research/env-trend · /api/research/experiments

// 两个研发中心（温湿度差异是本页对比的主线）
export const RESEARCH_CENTERS = [
  {
    key: 'chengdu',
    name: '成都研发中心',
    city: '四川 · 成都',
    altitude: '海拔 500 m',
    climate: '平原 · 温湿可控',
    staff: 18,
    area: '1 200 ㎡',
    color: '#31FFFF',
  },
  {
    key: 'luhuo',
    name: '炉霍研发中心',
    city: '四川 · 甘孜炉霍',
    altitude: '海拔 3 250 m',
    climate: '高原 · 低温低湿',
    staff: 9,
    area: '680 ㎡',
    color: '#FFC857',
  },
]

// 实验室环境指标（values 为两地实时值；range 为工艺适宜区间，超出即判定「偏离」）
export const ENV_METRICS = [
  { key: 'temp', label: '温度', unit: '℃', range: [20, 25], values: { chengdu: 23.6, luhuo: 17.4 }, digits: 1 },
  { key: 'humidity', label: '相对湿度', unit: '%', range: [45, 65], values: { chengdu: 52, luhuo: 37 }, digits: 0 },
  { key: 'pressure', label: '洁净压差', unit: 'Pa', range: [5, 20], values: { chengdu: 12, luhuo: 8 }, digits: 0 },
  { key: 'particle', label: '悬浮粒子(≥0.5μm)', unit: '万粒/m³', range: [0, 35], values: { chengdu: 28, luhuo: 46 }, digits: 0 },
  { key: 'co2', label: 'CO₂ 浓度', unit: 'ppm', range: [400, 1000], values: { chengdu: 620, luhuo: 540 }, digits: 0 },
  { key: 'lux', label: '照度', unit: 'lx', range: [300, 750], values: { chengdu: 520, luhuo: 480 }, digits: 0 },
]

// 24 小时环境趋势：成都温湿平稳，炉霍昼夜温差大、湿度更低（差异主线）
export const ENV_TREND = [
  { hour: '00', cdTemp: 22.8, lhTemp: 15.2, cdHum: 54, lhHum: 41 },
  { hour: '01', cdTemp: 22.6, lhTemp: 14.8, cdHum: 55, lhHum: 42 },
  { hour: '02', cdTemp: 22.4, lhTemp: 14.5, cdHum: 55, lhHum: 43 },
  { hour: '03', cdTemp: 22.3, lhTemp: 14.3, cdHum: 56, lhHum: 43 },
  { hour: '04', cdTemp: 22.2, lhTemp: 14.1, cdHum: 56, lhHum: 44 },
  { hour: '05', cdTemp: 22.4, lhTemp: 14.0, cdHum: 55, lhHum: 44 },
  { hour: '06', cdTemp: 22.8, lhTemp: 14.6, cdHum: 54, lhHum: 42 },
  { hour: '07', cdTemp: 23.1, lhTemp: 15.4, cdHum: 53, lhHum: 40 },
  { hour: '08', cdTemp: 23.4, lhTemp: 16.2, cdHum: 52, lhHum: 38 },
  { hour: '09', cdTemp: 23.6, lhTemp: 16.8, cdHum: 52, lhHum: 37 },
  { hour: '10', cdTemp: 23.8, lhTemp: 17.4, cdHum: 51, lhHum: 36 },
  { hour: '11', cdTemp: 24.0, lhTemp: 17.9, cdHum: 51, lhHum: 35 },
  { hour: '12', cdTemp: 24.1, lhTemp: 18.4, cdHum: 50, lhHum: 34 },
  { hour: '13', cdTemp: 24.2, lhTemp: 18.6, cdHum: 50, lhHum: 34 },
  { hour: '14', cdTemp: 24.0, lhTemp: 18.2, cdHum: 51, lhHum: 35 },
  { hour: '15', cdTemp: 23.9, lhTemp: 17.8, cdHum: 51, lhHum: 36 },
  { hour: '16', cdTemp: 23.7, lhTemp: 17.4, cdHum: 52, lhHum: 37 },
  { hour: '17', cdTemp: 23.6, lhTemp: 17.0, cdHum: 52, lhHum: 37 },
  { hour: '18', cdTemp: 23.5, lhTemp: 16.6, cdHum: 52, lhHum: 38 },
  { hour: '19', cdTemp: 23.4, lhTemp: 16.2, cdHum: 53, lhHum: 38 },
  { hour: '20', cdTemp: 23.3, lhTemp: 16.0, cdHum: 53, lhHum: 39 },
  { hour: '21', cdTemp: 23.2, lhTemp: 15.8, cdHum: 53, lhHum: 39 },
  { hour: '22', cdTemp: 23.0, lhTemp: 15.5, cdHum: 54, lhHum: 40 },
  { hour: '23', cdTemp: 22.9, lhTemp: 15.3, cdHum: 54, lhHum: 40 },
]

// 研发设备台账（status: running 运行中 / standby 待机 / calibrating 校准中 / offline 离线）
export const RESEARCH_DEVICES = [
  { name: '高速冷冻离心机', model: 'GL-21M', center: 'chengdu', category: '分离纯化', status: 'running', runtime: 6.5, load: 78, batches: 12, nextMaint: '2026-10-15' },
  { name: '等电点沉淀反应釜', model: 'FYA-500L', center: 'chengdu', category: '前处理', status: 'running', runtime: 5.2, load: 65, batches: 8, nextMaint: '2026-10-22' },
  { name: '超滤膜分离系统', model: 'UF-8040', center: 'chengdu', category: '分离纯化', status: 'running', runtime: 7.8, load: 82, batches: 15, nextMaint: '2026-10-08' },
  { name: '高效液相色谱仪', model: 'HPLC-1260', center: 'chengdu', category: '检测分析', status: 'running', runtime: 4.1, load: 54, batches: 22, nextMaint: '2026-11-02' },
  { name: '凯氏定氮仪', model: 'KDN-103F', center: 'chengdu', category: '检测分析', status: 'calibrating', runtime: 0, load: 0, batches: 0, nextMaint: '2026-09-30' },
  { name: '喷雾干燥塔', model: 'LPG-50', center: 'luhuo', category: '干燥制粉', status: 'running', runtime: 5.6, load: 71, batches: 9, nextMaint: '2026-10-18' },
  { name: '真空冷冻干燥机', model: 'FD-20', center: 'luhuo', category: '干燥制粉', status: 'standby', runtime: 1.2, load: 18, batches: 2, nextMaint: '2026-10-25' },
  { name: '激光粒度分析仪', model: 'MS-3000', center: 'luhuo', category: '检测分析', status: 'running', runtime: 3.4, load: 46, batches: 17, nextMaint: '2026-11-10' },
  { name: '恒温恒湿试验箱', model: 'HWS-800', center: 'luhuo', category: '环境模拟', status: 'running', runtime: 9.1, load: 60, batches: 6, nextMaint: '2026-10-12' },
  { name: '巴氏杀菌机组', model: 'BSJ-2000', center: 'luhuo', category: '前处理', status: 'offline', runtime: 0, load: 0, batches: 0, nextMaint: '2026-10-05' },
]

// 设备总览（示例汇总值，真实环境由设备台账统计得出）
export const DEVICE_SUMMARY = {
  total: 42,
  byCenter: { chengdu: 26, luhuo: 16 },
  running: 31,
  standby: 6,
  calibrating: 3,
  offline: 2,
  powerOnRate: 88.1,   // 开机率 %
  oee: 76.4,           // 设备综合利用率 %
  todayBatches: 91,    // 今日实验批次
  monthExperiments: 268,
}

// 双中心实验结果差异（同一实验方法在两地并行，因温湿度不同产生差异）
// better: 'chengdu' | 'luhuo'；lowerBetter 用于判断哪一方更优
export const EXPERIMENT_DIFF = [
  { item: '酪蛋白得率', unit: '%', chengdu: 82.6, luhuo: 79.4, lowerBetter: false, better: 'chengdu', note: '低温下胶束凝聚偏慢，转移损失略增' },
  { item: '产品纯度', unit: '%', chengdu: 92.1, luhuo: 93.4, lowerBetter: false, better: 'luhuo', note: '低湿环境杂菌控制更好，纯度略高' },
  { item: '成品水分', unit: '%', chengdu: 8.2, luhuo: 6.5, lowerBetter: true, better: 'luhuo', note: '炉霍湿度低，干燥更充分' },
  { item: '溶解时间', unit: 's', chengdu: 46, luhuo: 58, lowerBetter: true, better: 'chengdu', note: '低温复溶慢，需延长搅拌时间' },
  { item: '灰分', unit: '%', chengdu: 2.1, luhuo: 2.3, lowerBetter: true, better: 'chengdu', note: '高原水质硬度略高，灰分微增' },
  { item: '色泽 L 值', unit: '', chengdu: 86.5, luhuo: 88.2, lowerBetter: false, better: 'luhuo', note: '低温干燥褐变少，色泽更亮' },
]

// 差异归因结论（右侧说明卡）
export const DIFF_REASONS = [
  '炉霍海拔 3 250 m，年均气温较成都低约 6 ℃、相对湿度低约 15 个百分点。',
  '低温低湿使干燥更快：成品水分低 1.7%、色泽更亮；但复溶慢 12 s、得率降 3.2%。',
  '建议：炉霍中心对「溶解性 / 得率」类实验增设 22 ℃恒温复溶工序，成都作基准对照。',
]

// 直播接入端口预留（url 为空 = 待接入；支持 RTMP / HLS(m3u8) / FLV，大屏端建议网关转封装）
export const LIVE_PORTS = [
  { key: 'chengdu', name: '成都研发中心 · 实验直播', center: '成都研发中心', url: '', inputUrl: '', status: 'idle' },
  { key: 'luhuo', name: '炉霍研发中心 · 实验直播', center: '炉霍研发中心', url: '', inputUrl: '', status: 'idle' },
]

export const RESEARCH_UPDATED_AT = '2026-09-28 15:30'

// =====================================================================
// 参考图版「酪蛋白研发中心实时数据看板」数据（7680×2160 · 5 列网格 7 面板）
// =====================================================================

// 研发项目总览（statusKey: done 已完成 / declared 已申报 / pending 待申报 / doing 进行中）
export const PANEL_PROJECTS = [
  { name: 'A2b-酪蛋白研发', statusKey: 'done', status: '已完成' },
  { name: '乳清蛋白研发', statusKey: 'done', status: '已完成' },
  { name: '乳铁蛋白研发', statusKey: 'declared', status: '已申报' },
  { name: '乳桥蛋白研发', statusKey: 'declared', status: '已申报' },
  { name: '共轭亚油酸研发', statusKey: 'pending', status: '待申报' },
  { name: '酪蛋白磷酸肽研发', statusKey: 'doing', status: '进行中' },
]
export const PANEL_PROJECT_TOTAL = 20

// 成都VS炉霍 产品试验：分组柱状图（单位 %）
export const PANEL_TRIAL = {
  cdLabel: '成都 22℃ 20Pa 60%RH 十万级',
  lhLabel: '炉霍 17℃ 10Pa 45%RH 十万级',
  categories: ['A2β-酪蛋白', '乳清蛋白', '乳铁蛋白', '乳桥蛋白', '共轭亚油酸'],
  chengdu: [85, 85, 95, 90, 78],
  luhuo: [83, 82, 91, 88, 80],
}

// 研发专利（21 项，来源：H盘-自主产品-炉霍项目申报-数字看板-专利证书及论文/专利证书）
// no = 专利号，img = 证书扫描图（public/assets/research/patents/p01-p21.jpg），点击可全屏放大
export const PANEL_PATENTS = [
  { name: '一种酪蛋白分离段流量控制调节装置', no: 'ZL 2017 2 0525442.7', img: 'assets/research/patents/p01.jpg' },
  { name: '一种酪蛋白加工用喷雾干燥机用清理装置', no: 'ZL 2020 2 2524169.0', img: 'assets/research/patents/p02.jpg' },
  { name: '一种酪蛋白加工用杀菌机进料挡板装置', no: 'ZL 2020 2 2525016.8', img: 'assets/research/patents/p03.jpg' },
  { name: '一种酪蛋白加工中用于杀灭奶液中的细菌的灭菌机', no: 'ZL 2020 2 2530085.8', img: 'assets/research/patents/p04.jpg' },
  { name: '一种酪蛋白用多功能冷却罐', no: 'ZL 2020 2 2531273.2', img: 'assets/research/patents/p05.jpg' },
  { name: '一种新型的酪蛋白用冷却罐', no: 'ZL 2020 2 2530722.1', img: 'assets/research/patents/p06.jpg' },
  { name: '一种酪蛋白加工用杀菌机用支撑装置', no: 'ZL 2020 2 2525761.2', img: 'assets/research/patents/p07.jpg' },
  { name: '一种酪蛋白加工用除去奶液中的杂质用分离机网筛设备', no: 'ZL 2020 2 2525026.1', img: 'assets/research/patents/p08.jpg' },
  { name: '一种酪蛋白加工用高效可视均质机', no: 'ZL 2020 2 2575455.X', img: 'assets/research/patents/p09.jpg' },
  { name: '一种酪蛋白加工用喷雾干燥机用分料装置', no: 'ZL 2020 2 2524184.5', img: 'assets/research/patents/p10.jpg' },
  { name: '一种酪蛋白加工用锥形混料机用上料装置', no: 'ZL 2020 2 2530113.6', img: 'assets/research/patents/p11.jpg' },
  { name: '一种酪蛋白加工中用于溶解奶渣颗粒的搅拌罐用清洁装置', no: 'ZL 2020 2 2531289.3', img: 'assets/research/patents/p12.jpg' },
  { name: '一种酪蛋白加工中用于溶解奶渣颗粒的节能搅拌罐', no: 'ZL 2020 2 2531288.9', img: 'assets/research/patents/p13.jpg' },
  { name: '一种酪蛋白加工用杀灭奶液中的细菌用灭菌机的下料装置', no: 'ZL 2020 2 2573119.1', img: 'assets/research/patents/p14.jpg' },
  { name: '一种用于混合酪蛋白颗粒的锥形混料机', no: 'ZL 2020 2 2573133.1', img: 'assets/research/patents/p15.jpg' },
  { name: '一种灭菌机', no: 'ZL 2023 2 1289332.7', img: 'assets/research/patents/p16.jpg' },
  { name: '一种效果好的反渗透装置', no: 'ZL 2023 2 1592582.8', img: 'assets/research/patents/p17.jpg' },
  { name: '一种搅拌罐', no: 'ZL 2023 2 1900763.2', img: 'assets/research/patents/p18.jpg' },
  { name: '一种高效酸化设备', no: 'ZL 2023 2 1979598.4', img: 'assets/research/patents/p19.jpg' },
  { name: '一种混料均匀的混料机', no: 'ZL 2023 2 2259295.1', img: 'assets/research/patents/p20.jpg' },
  { name: '一种可连续喷淋的灭菌机', no: 'ZL 2024 2 1610256.X', img: 'assets/research/patents/p21.jpg' },
]

// 论文区（3 篇，来源：H盘-自主产品-炉霍项目申报-数字看板-专利证书及论文/论文）
// file = PDF 全文（public/assets/research/papers/paper-1~3.pdf），点击标题在弹层阅读
export const PANEL_PAPERS = [
  { title: '菌酶协同发酵水解牦牛乳酪蛋白产ACE抑制肽工艺优化与肽段鉴定及稳定性分析', file: 'assets/research/papers/paper-1.pdf' },
  { title: '牦牛乳酪蛋白磷酸肽纯化工艺优化及其促钙吸收作用', file: 'assets/research/papers/paper-2.pdf' },
  { title: '动物双歧杆菌动物亚种联合传统发酵剂对发酵乳体外降血糖与抗氧化特性的影响', file: 'assets/research/papers/paper-3.pdf' },
]

// 三维分子结构（点击研发项目进入分子下级页；结构文件取自 public/assets/research/molecules）
// project 与 PANEL_PROJECTS 的 name 对应；style: protein 卡通 / peptide 球棍 / ligand 球棍
// 结构文件为 PDB/SDF 坐标格式（SWISS-MODEL / RCSB PDB 同源），由 3Dmol.js 渲染为可交互三维
//
// 分子结构分析展示辅助数据（置信度曲线 / 氨基酸组成 / 磷酸化板 / 悬浮球状体）
// genPLDDT：确定性地生成逐残基 pLDDT 置信度曲线（AlphaFold 风格：核心区高、loop/末端低），
//   不依赖运行时随机，保证刷新后曲线稳定一致。
function genPLDDT(n, mean, seed) {
  if (!n || n <= 0) return []
  const arr = []
  let s = seed || 1
  for (let i = 0; i < n; i++) {
    s = (s * 9301 + 49297) % 233280
    const r = s / 233280
    const wave = Math.sin((i / n) * Math.PI * 3.2 + (seed % 7)) * 7
    let v = mean + wave + (r - 0.5) * 20
    // N/C 端 8% 区域置信度下降（无序区）
    const edge = Math.min(i, n - 1 - i) / (n * 0.08)
    if (edge < 1) v -= (1 - edge) * 18
    v = Math.max(38, Math.min(96, v))
    arr.push(Math.round(v))
  }
  return arr
}

export const MOLECULES = [
  { project: 'A2b-酪蛋白研发', molecule: 'A2b β-酪蛋白', file: 'assets/research/molecules/m01_beta-casein.pdb', format: 'pdb', style: 'protein', img: 'assets/research/molecules/m01.jpg', source: 'SWISS-MODEL / RCSB PDB', gene: 'CSN2', acc: 'P02666', residues: 209, pLDDT: genPLDDT(209, 73, 11), aaTop: [{ code: 'GLU', name: '谷氨酸', pct: 12.4 }, { code: 'PRO', name: '脯氨酸', pct: 11.2 }, { code: 'LEU', name: '亮氨酸', pct: 9.8 }, { code: 'SER', name: '丝氨酸', pct: 8.6 }, { code: 'LYS', name: '赖氨酸', pct: 8.1 }, { code: 'VAL', name: '缬氨酸', pct: 6.7 }, { code: 'ALA', name: '丙氨酸', pct: 5.9 }, { code: 'GLY', name: '甘氨酸', pct: 4.5 }], phospho: { sites: [15, 17, 18, 19, 34, 35, 46, 69, 74], estimated: 3 }, intro: 'A2b β-酪蛋白是牦牛乳酪蛋白主要组分，约占酪蛋白总量的 55%~60%，由 209 个氨基酸组成，富含脯氨酸与磷酸丝氨酸簇，决定酪蛋白胶束的组装与钙结合能力。A2b 型与 A1 型的区别在于第 67 位氨基酸为脯氨酸，消化过程中不产生 β-酪啡肽-7（BCM-7），更亲和人体。' },
  { project: '乳清蛋白研发', molecule: 'α-乳白蛋白', file: 'assets/research/molecules/m02_alpha-lactalbumin.pdb', format: 'pdb', style: 'protein', img: 'assets/research/molecules/m02.jpg', source: 'SWISS-MODEL / RCSB PDB', gene: 'LALBA', acc: 'P00711', residues: 123, pLDDT: genPLDDT(123, 78, 23), aaTop: [{ code: 'LEU', name: '亮氨酸', pct: 11.8 }, { code: 'LYS', name: '赖氨酸', pct: 10.9 }, { code: 'ASP', name: '天冬氨酸', pct: 9.6 }, { code: 'GLU', name: '谷氨酸', pct: 9.2 }, { code: 'VAL', name: '缬氨酸', pct: 7.6 }, { code: 'ILE', name: '异亮氨酸', pct: 7.1 }, { code: 'TYR', name: '酪氨酸', pct: 6.4 }, { code: 'PHE', name: '苯丙氨酸', pct: 4.7 }], phospho: { sites: [], estimated: 0 }, intro: 'α-乳白蛋白是乳清中主要的钙结合球状蛋白，由 123 个氨基酸组成，含 4 个 α-螺旋与 8 个半胱氨酸形成的 4 对二硫键，结构紧密稳定，富含色氨酸，是母乳化配方奶粉的关键功能蛋白，参与乳糖合成调节。' },
  { project: '乳铁蛋白研发', molecule: '乳铁蛋白', file: 'assets/research/molecules/m03_lactoferrin.pdb', format: 'pdb', style: 'protein', img: 'assets/research/molecules/m03.jpg', source: 'SWISS-MODEL / RCSB PDB', gene: 'LTF', acc: 'P02788', residues: 691, pLDDT: genPLDDT(691, 70, 31), aaTop: [{ code: 'LEU', name: '亮氨酸', pct: 8.4 }, { code: 'ALA', name: '丙氨酸', pct: 7.9 }, { code: 'SER', name: '丝氨酸', pct: 7.5 }, { code: 'GLY', name: '甘氨酸', pct: 7.1 }, { code: 'VAL', name: '缬氨酸', pct: 6.8 }, { code: 'ASP', name: '天冬氨酸', pct: 6.6 }, { code: 'LYS', name: '赖氨酸', pct: 6.4 }, { code: 'THR', name: '苏氨酸', pct: 5.9 }], phospho: { sites: [], estimated: 0 }, intro: '乳铁蛋白为约 80 kDa 的铁结合糖蛋白，由 691 个氨基酸组成，N/C 两端叶状结构各可结合一个 Fe³⁺（共 2 个），具有抗菌、抗病毒、免疫调节与促铁吸收等多重生理功能，是牦牛乳深加工的高附加值活性蛋白。' },
  { project: '乳桥蛋白研发', molecule: '骨桥蛋白（乳桥蛋白）', file: 'assets/research/molecules/m04_osteopontin.pdb', format: 'pdb', style: 'protein', img: 'assets/research/molecules/m04.jpg', source: 'SWISS-MODEL / RCSB PDB', gene: 'SPP1', acc: 'P10451', residues: 260, pLDDT: genPLDDT(260, 68, 41), aaTop: [{ code: 'SER', name: '丝氨酸', pct: 12.6 }, { code: 'ASP', name: '天冬氨酸', pct: 10.8 }, { code: 'GLU', name: '谷氨酸', pct: 10.4 }, { code: 'LEU', name: '亮氨酸', pct: 8.2 }, { code: 'GLY', name: '甘氨酸', pct: 7.1 }, { code: 'THR', name: '苏氨酸', pct: 6.8 }, { code: 'PRO', name: '脯氨酸', pct: 6.2 }, { code: 'ALA', name: '丙氨酸', pct: 5.6 }], phospho: { sites: [10, 12, 15, 17, 20, 23, 28, 30, 40, 45, 58, 62, 75, 80, 95, 100, 110, 120, 130, 140], estimated: 5 }, intro: '乳桥蛋白（OPN，骨桥蛋白）是高度磷酸化糖蛋白，由约 260 个氨基酸组成，含多个连续磷酸丝氨酸簇，参与生物矿化、细胞黏附与免疫调节；在乳中作为乳桥蛋白发挥钙螯合与乳化稳定作用，含量仅为乳蛋白的千分之几，极为珍稀。' },
  { project: '共轭亚油酸研发', molecule: '共轭亚油酸（CLA）', file: 'assets/research/molecules/m05_cla.sdf', format: 'sdf', style: 'ligand', img: 'assets/research/molecules/m05.jpg', source: 'PubChem', gene: '—', acc: 'CID 5282181', isLigand: true, residues: 0, pLDDT: [], aaTop: null, phospho: null, intro: '共轭亚油酸（CLA）是一组亚油酸的位置与几何异构体，分子式 C₁₈H₃₂O₂，主要有 c9,t11 与 t10,c12 两种活性构型，具有调节体脂代谢、增强免疫等生理功能；牦牛乳脂肪中 CLA 含量显著高于普通牛乳。' },
  { project: '酪蛋白磷酸肽研发', molecule: '酪蛋白磷酸肽（CPP）', file: 'assets/research/molecules/m06_cpp.pdb', format: 'pdb', style: 'peptide', img: 'assets/research/molecules/m06.jpg', source: '自建模型', gene: 'CSN1S1 / CPP', acc: '酶解产物', residues: 25, pLDDT: genPLDDT(25, 75, 61), aaTop: [{ code: 'SER', name: '丝氨酸', pct: 18.0 }, { code: 'GLU', name: '谷氨酸', pct: 14.0 }, { code: 'LYS', name: '赖氨酸', pct: 9.0 }, { code: 'VAL', name: '缬氨酸', pct: 7.0 }, { code: 'ASP', name: '天冬氨酸', pct: 6.0 }, { code: 'PRO', name: '脯氨酸', pct: 5.0 }, { code: 'THR', name: '苏氨酸', pct: 4.0 }, { code: 'LEU', name: '亮氨酸', pct: 3.5 }], phospho: { sites: [1, 2, 3, 5, 8, 11, 14, 17, 20], estimated: 2 }, intro: '酪蛋白磷酸肽（CPP）由酪蛋白经胰蛋白酶定向酶解得到，核心含簇集磷酸丝氨酸序列（Ser(Ser,Glu)₂），呈"酸性磷酸簇+碱性残基"两性结构，可在中性肠道环境中螯合钙、铁、锌等矿物离子形成可溶复合物，促进矿物质吸收。' },
]

// 设备运行情况（status: running 运行中 / standby 待机中）
export const PANEL_DEVICE_TOTAL = 35
export const PANEL_DEVICES = [
  { name: '气质联用仪', status: 'running' },
  { name: '液相色谱仪', status: 'running' },
  { name: '荧光检测器', status: 'running' },
  { name: '恒温干燥箱', status: 'standby' },
  { name: '液质联用仪', status: 'standby' },
  { name: '凝胶色谱仪', status: 'running' },
  { name: '乳脂离心机', status: 'running' },
  { name: '毛氏震荡器', status: 'running' },
  { name: '恒温培养箱', status: 'running' },
]
